// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"241":"a990620f86cc26d50a14","616":"1295a7039770ca6e961b"}[chunkId] + ".css";
};